// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useState } from 'react'
import './ProviderTile.scss'
import { FullTextToolTip, UserImage } from 'ui_kit_qmd'
import moment from 'moment-timezone'
import { findIana } from 'windows-iana'
import { allTimezones, useTimezoneSelect } from 'react-timezone-select'
import { styles, text } from './Constants'
import { TimeTile } from '../../../time-tile/TimeTile'
import { parseUserDateTime, getTimeZones } from '../../../../../../utils/common'
import { DEFAULT_DATE_FORMAT_WITHOUT_TIME } from '../../../../../../utils/dateUtils'
import { getVisitMethodIconProps } from '../../getVisitMethodIconProps'

export const ProviderTile = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  imageUrl,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  providerName,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitTypeName,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  method,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  providerTitles,
  timeSlots = [],
  isCompactView = false,
  isReschedule = false,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  providerId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  reschedulePrimaryClick,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setProviderInfo,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  date,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  timeZone,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitTimeZone,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitTime,
}) => {
  const [selectedTime, setSelectedTime] = useState(null)
  const timezones = getTimeZones(allTimezones)
  const { parseTimezone } = useTimezoneSelect({ timezones, labelStyle: 'abbrOnly' })

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const combineDateAndTime = (selectedTimeArg) => {
    // Combine date and time into a single moment object
    const formattedDateTime = moment
      .tz(`${date} ${selectedTimeArg}`, 'dddd MMM DD YYYY hh:mma', timeZone)
      .set({ second: 0, millisecond: 0 }) // Ensure milliseconds and seconds are explicitly set
      .format('YYYY-MM-DDTHH:mm:ss.SSSZ') // Format with milliseconds and timezone offset

    return formattedDateTime
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const handleTimeTileClick = (time) => {
    setSelectedTime(time)
    const combinedDateTime = combineDateAndTime(time)

    setProviderInfo({
      providerId,
      providerName,
      dateTime: combinedDateTime,
    })

    reschedulePrimaryClick({
      providerId,
      providerName,
      dateTime: combinedDateTime,
    })
  }

  const formatVisitDetails = () => {
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    if (!visitTimeZone) return text.UNAVAILABLE

    const ianaTimeZone = findIana(visitTimeZone)[0]
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    const formattedTime = moment.utc(visitTime).tz(ianaTimeZone).format('MMM DD YYYY, h:mma')
    const timezoneLabel = parseTimezone(
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      ianaTimeZone,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      moment.utc(visitTime).tz(ianaTimeZone).format(DEFAULT_DATE_FORMAT_WITHOUT_TIME),
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      moment.utc(visitTime).tz(ianaTimeZone).format('h:mma'),
    ).label

    return `${formattedTime} ${timezoneLabel}`
  }

  const containerClassName =
    timeSlots.length > 0 ? 'new-visit-provider-tile-container-time-slot' : 'new-visit-provider-tile-container'

  return (
    <div className={containerClassName}>
      {timeSlots.length > 0 || isCompactView ?
        <div className='new-visit-provider-tile-compact-row'>
          {imageUrl ?
            <img src={imageUrl} className='new-visit-provider-tile-image' alt={text.PROVIDER} />
          : <UserImage image={imageUrl} size={80} />}

          <FullTextToolTip
            id='new-visit-provider-tile-name'
            fullText={providerName}
            extraStyle={styles.NAME_TOOLTIP}
            view={
              <label htmlFor='null' className='new-visit-provider-tile-name'>
                {providerName}
              </label>
            }
          />
        </div>
      : <>
          {imageUrl ?
            <img src={imageUrl} className='new-visit-provider-tile-image' alt={text.PROVIDER} />
          : <UserImage image={imageUrl} size={80} />}

          <div className='new-visit-provider-tile-info-container'>
            <FullTextToolTip
              id='new-visit-provider-tile-name'
              fullText={providerName}
              extraStyle={styles.NAME_TOOLTIP}
              view={
                <label htmlFor='null' className='new-visit-provider-tile-name' id='new-visit-provider-tile-name'>
                  <div />
                  {providerName}
                </label>
              }
            />

            {isReschedule ?
              <FullTextToolTip
                fullText={`${parseUserDateTime(visitTime, timeZone, true)} (${text.PATIENT} ${formatVisitDetails()})`}
                extraStyle={{ bottom: 50 }}
                view={
                  <span style={{ marginBottom: 0 }} className='visit-card-name-label'>
                    {parseUserDateTime(visitTime, timeZone, true)} ({text.PATIENT} {formatVisitDetails()})
                  </span>
                }
              />
            : null}
            {!isReschedule && (
              <FullTextToolTip
                id='new-visit-provider-tile-titles'
                fullText={providerTitles || visitTypeName}
                extraStyle={styles.TITLES_TOOLTIP}
                view={
                  <label htmlFor='null' className='new-visit-provider-tile-titles' id='new-visit-provider-tile-titles'>
                    {isReschedule ?
                      <img
                        {...getVisitMethodIconProps(method)}
                        className='visit-card-type-icon'
                        style={{ verticalAlign: 'middle', marginRight: '8px', marginTop: '0' }}
                      />
                    : null}
                    {providerTitles || visitTypeName}
                  </label>
                }
              />
            )}
          </div>
        </>
      }
      {timeSlots.length > 0 && (
        <div className='new-visit-provider-tile-time-slots'>
          {timeSlots.map((time) => (
            <TimeTile
              key={time}
              timeValue={time}
              setIsSelected={() => handleTimeTileClick(time)}
              isSelected={selectedTime === time}
            />
          ))}
        </div>
      )}
    </div>
  )
}
